import { render, staticRenderFns } from "./product_media_gallery.html?vue&type=template&id=8c2054b0&scoped=true&"
import script from "./product_media_gallery.ts?vue&type=script&lang=js&"
export * from "./product_media_gallery.ts?vue&type=script&lang=js&"
import style0 from "./product_media_gallery.scss?vue&type=style&index=0&id=8c2054b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2054b0",
  null
  
)

export default component.exports